/* eslint-disable */
module.exports = require('./lib/ParcelBoundary.js');
